<div *ngIf="compoundActiveItem$ | async as item">
  <app-compound-item-panel-atom
    [title]="item.name"
    [products]="item.products"
    [count]="item.count"
    [minCount]="item.min_count"
    [parentIdOfAdditions]="parentIdOfAdditions"
    [selected]="item.selected"
    [isMobile]="isMobileScreen$ | async"
    [index]="index$ | async"
    [storeId]="item.store_id"
    [headingColor]="headingColor"
    [descriptionColor]="descriptionColor"
    [inactiveStateColor]="inactiveStateColor"
    [priceColor]="priceColor"
    (openAdditionsPanel)="openAdditionsPanel($event)"
    (updateProducts)="onUpdateProducts($event, item.store_id)"
    (outStoreId)="onValidItem($event)"
    (closeModal)="onCloseModal()"
    [hideAdditionGroupDetails]="hideAdditionGroupDetails"
  ></app-compound-item-panel-atom>
  <div *ngIf="additions?.length">
    <app-compound-item-panel-atom
      [products]="additions"
      [title]="additionGroup.name"
      [parentIdOfAdditions]="parentIdOfAdditions"
      [isAdditionPanel]="true"
      [selected]="item.selected"
      [count]="additionGroup.max_count"
      [minCount]="additionGroup.min_count"
      [groupId]="groupId"
      [isMobile]="isMobileScreen$ | async"
      [index]="index$ | async"
      [headingColor]="headingColor"
      [descriptionColor]="descriptionColor"
      [inactiveStateColor]="inactiveStateColor"
      [priceColor]="priceColor"
      (updateProducts)="onUpdateAdditions($event, item.store_id)"
      (closeModal)="onCloseAdditions()"
      [hideAdditionGroupDetails]="hideAdditionGroupDetails"
    ></app-compound-item-panel-atom>
  </div>
</div>
